import { SearchServiceSort } from "../../hooks";

import isArray from "../../../utils/IsArray";

import request from "../base-request";

export const SERVICE_REVIEW = "review";
export const SERVICE_FORMS = "review_report";
export const SERVICE_REVIEW_CYCLE = "review_cycle";
export const SERVICE_FEEDBACK = "feedback";
export const SERVICE_FEEDBACK_COMPANY = "feedback_company";
export const SERVICE_FEEDBACK_REQUEST = "feedback_request";
export const SERVICE_GOAL = "goal";

export type SearchServiceResponse<T> = {
	errors?: string[];
	params?: {
		limit: number;
		skip: number;
		sort_direction: string;
		sort_field: string;
		search_fields_and_operators: Array<{
			field: string;
			operator: string;
			value: any;
		}>;
	};
	//as we add more search services, add result types here
	results: Array<T>;
	total: number;
	warnings: string[];
	jobID: string;
};

export const getSearch = async <T>(
	service: string,
	filters: any,
	skip: number,
	limit: number,
	sort?: SearchServiceSort,
	isCsv = false
) => {
	let url = `/api/search/?service=${service}`;
	// uncomment this to recieve more information about the pipeline that was ran with teh response.
	// Helps debug some permissions issues.
	//url += `&debug=true`;

	if (filters) {
		Object.keys(filters).forEach((key) => {
			const value = isArray(filters[key]) ? filters[key].join(",") : filters[key];
			url += `&${key}=${encodeURIComponent(value)}`;
		});
	}

	if (sort) {
		url += `&sort=${sort.direction}(${sort.name})`;
	}

	if (skip) {
		url += `&skip=${skip}`;
	}

	if (limit) {
		url += `&limit=${limit}`;
	}

	if (isCsv) {
		url += `&format=csv`;
	}

	try {
		const [data] = await request<SearchServiceResponse<T>>(url);

		if (data.errors) {
			data.errors.forEach((error) => {
				throw new Error(error);
			});
		}

		return data;
	} catch (error) {
		throw error;
	}
};
